import {
  CORE_DELETE_EVENT_SEAT_REQUEST,
  CORE_DELETE_EVENT_SEAT_SUCCESS,
  CORE_DELETE_EVENT_SEAT_FAILURE,
} from '../types'
const requestState = 'request'
  , initialStateObj = {}

export default {
  eventSeatDelete: (state = requestState, action) => {
    switch (action.type) {
      case CORE_DELETE_EVENT_SEAT_REQUEST:
        return requestState
      case CORE_DELETE_EVENT_SEAT_SUCCESS:
        let result = {}
        if (Object.keys(action.payload).length > 0) {
          result = action.payload
        }
        return result
      case CORE_DELETE_EVENT_SEAT_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerDelete.js